export default __webpack_public_path__ + "2239711e1862d4d4c2c39b18e9718068.gif";